import mapKeys from 'lodash/mapKeys'

import { DETAIL_USER_GROUP_ADD_FULFILLED, DETAIL_USER_GROUP_REMOVE_FULFILLED } from 'Modules/UserDetailModule/actionTypes'
import { GROUP_DELETE_FULFILLED, GROUP_SET_NAME_FULFILLED, GROUP_SET_PERMISSIONS_FULFILLED } from 'Global/Stores/group'
import { SIGN_OUT } from 'Global/Stores/auth'

const GROUP_CREATE = 'API|GROUP/CREATE'
export const GROUP_CREATE_FULFILLED = `FULFILLED_${GROUP_CREATE}`
const GROUP_CREATE_PENDING = `PENDING_${GROUP_CREATE}`
const GROUP_CREATE_REJECTED = `REJECTED_${GROUP_CREATE}`

const GROUPS_GET_ALL = 'API|GROUPS/GET_ALL'
const GROUPS_GET_ALL_FULFILLED = `FULFILLED_${GROUPS_GET_ALL}`
const GROUPS_GET_ALL_PENDING = `PENDING_${GROUPS_GET_ALL}`
const GROUPS_GET_ALL_REJECTED = `REJECTED_${GROUPS_GET_ALL}`

export const groupCreate = name => {
  return {
    meta: { data: { name }, method: 'post', url: `/api/v1/groups/` },
    type: GROUP_CREATE,
  }
}

export const groupsGet = () => {
  return {
    meta: { url: `/api/v1/groups/getAll` },
    type: GROUPS_GET_ALL,
  }
}

const initialState = {
  data: {},
  create: {
    createdGroup: null,
    hasError: false,
    isPending: false,
  },
  done: false,
  error: false,
  pending: false,
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
    case GROUP_CREATE_FULFILLED:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.data.id]: {
            ...payload.data,
          },
        },
        create: {
          ...state.create,
          createdGroup: payload.data.id,
          hasError: false,
          isPending: false,
        },
      }

    case GROUP_CREATE_PENDING:
      return {
        ...state,
        create: {
          ...state.create,
          hasError: false,
          isPending: true,
        },
      }

    case GROUP_CREATE_REJECTED:
      return {
        ...state,
        create: {
          ...state.create,
          hasError: true,
          isPending: false,
        },
      }

    case GROUPS_GET_ALL_FULFILLED:
      return {
        ...state,
        data: mapKeys(payload.data, 'id'),
        done: true,
        error: false,
        pending: false,
      }

    case GROUPS_GET_ALL_PENDING:
      return {
        ...state,
        done: false,
        error: false,
        pending: true,
      }

    case GROUPS_GET_ALL_REJECTED:
      return {
        ...state,
        done: true,
        error: true,
        pending: false,
      }

    // External

    case GROUP_DELETE_FULFILLED:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.data.id]: {
            ...state.data[payload.data.id],
            wasDeleted: true,
          },
        },
      }

    case DETAIL_USER_GROUP_ADD_FULFILLED:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.data.addedGroup]: {
            ...state.data[payload.data.addedGroup],
            users: [...state.data[payload.data.addedGroup].users, payload.data.id],
          },
        },
      }

    case DETAIL_USER_GROUP_REMOVE_FULFILLED:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.data.removedGroup]: {
            ...state.data[payload.data.removedGroup],
            users: state.data[payload.data.removedGroup].users.filter(user => user !== payload.data.id),
          },
        },
      }

    case GROUP_SET_NAME_FULFILLED:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.data.id]: {
            ...state.data[payload.data.id],
            name: payload.data.name,
          },
        },
      }

    case GROUP_SET_PERMISSIONS_FULFILLED:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.data.id]: {
            ...state.data[payload.data.id],
            permissions: payload.data.permissions,
          },
        },
      }

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
